export const LOGIN_SCHOOL_SELECTION_STORAGE_KEY = "lastSelectedLoginSchool";

export const formatLoginSchoolLabel = (school) => {
  if (!school) return "";
  const name = school.schoolName || school.name || "School";
  return school.schoolCode ? `${name} (${school.schoolCode})` : name;
};

export const readSelectedLoginSchool = () => {
  try {
    const raw = localStorage.getItem(LOGIN_SCHOOL_SELECTION_STORAGE_KEY);
    const school = raw ? JSON.parse(raw) : null;
    return school?.schoolCode ? school : null;
  } catch (error) {
    localStorage.removeItem(LOGIN_SCHOOL_SELECTION_STORAGE_KEY);
    return null;
  }
};

export const saveSelectedLoginSchool = (school) => {
  if (!school?.schoolCode) return;
  localStorage.setItem(LOGIN_SCHOOL_SELECTION_STORAGE_KEY, JSON.stringify(school));
};

export const clearSelectedLoginSchool = () => {
  localStorage.removeItem(LOGIN_SCHOOL_SELECTION_STORAGE_KEY);
};
